import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { DtcFilesTable } from '../../../../../../../../../../../features/dtc/files/v1/dtc-files-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/dtcc/_dtcc/file/_file/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorDtcc,
      label: 'DTC Files',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorDtcc>,
  head: () => getPageHead('DTC Files'),
  component: DtcFilesList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorDtcc}
    />
  );
}

function DtcFilesList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DtcFilesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
